import { create } from 'zustand';

import { toPlayerMessage } from '@/shared/api';
import { isFresh, singleFlight } from '@/shared/lib';

import { fetchRewardTrack } from '../api/reward-track.api';

import type { RewardTrack } from './types';

interface RewardTrackStoreState {
  track: RewardTrack | null;
  isLoading: boolean;
  error: string | null;
  loadedAt: number | null;

  load: (options?: { force?: boolean }) => Promise<void>;
  reset: () => void;
}

export const useRewardTrackStore = create<RewardTrackStoreState>()(
  (set, get) => ({
    track: null,
    isLoading: false,
    error: null,
    loadedAt: null,

    load: singleFlight(async (options?: { force?: boolean }): Promise<void> => {
      if (!options?.force && isFresh(get().loadedAt)) return;

      set({ isLoading: true, error: null });
      try {
        set({ track: await fetchRewardTrack(), loadedAt: Date.now() });
      } catch (error) {
        set({ error: toPlayerMessage(error) });
      } finally {
        set({ isLoading: false });
      }
    }),

    reset: () => {
      set({ track: null, error: null, loadedAt: null });
    },
  }),
);
